import { i18n as I18n } from 'i18next'
import { useTranslation } from 'react-i18next'
import { DEFAULT_LOCALE, normalizeLocale, SupportedLocale } from 'ClientPortal/src/i18n/supportedLocales'

type LocaleSource = Pick<I18n, 'resolvedLanguage' | 'language'>

export function getCurrentResolvedLocale(i18n: LocaleSource): SupportedLocale {
    return normalizeLocale(i18n.resolvedLanguage ?? i18n.language) || DEFAULT_LOCALE
}

export function useCurrentResolvedLocale(): SupportedLocale {
    // Bind to a bundled namespace; the app does not provide i18next's default `translation` namespace.
    const { i18n } = useTranslation('terminology')

    return getCurrentResolvedLocale(i18n)
}
